import { render, staticRenderFns } from "./ServiceSection.vue?vue&type=template&id=1774a087&scoped=true"
import script from "./ServiceSection.vue?vue&type=script&lang=js"
export * from "./ServiceSection.vue?vue&type=script&lang=js"
import style0 from "./ServiceSection.vue?vue&type=style&index=0&id=1774a087&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1774a087",
  null
  
)

export default component.exports